import { render, staticRenderFns } from "./projects.vue?vue&type=template&id=444c8faa&scoped=true"
import script from "./projects.vue?vue&type=script&lang=ts"
export * from "./projects.vue?vue&type=script&lang=ts"
import style0 from "./projects.vue?vue&type=style&index=0&id=444c8faa&prod&scoped=true&lang=css"
import style1 from "./projects.vue?vue&type=style&index=1&id=444c8faa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444c8faa",
  null
  
)

export default component.exports